/* ORDO — scripts propios (prefijo mt-). Vanilla, sin librerías. */
(function () {
  if (window.mtIniciado) return;
  window.mtIniciado = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatoDinero(centimos) {
    var fmt = (window.mtMoneda && window.mtMoneda.formato) || '{{amount_with_comma_separator}} €';
    var valor = (centimos / 100).toFixed(2);
    var partes = valor.split('.');
    var miles = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, miles + ',' + partes[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, miles)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount\s*\}\}/, partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + partes[1]);
  }

  /* ---------- Reveals ---------- */
  var observador = null;
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observador.unobserve(e.target);
            if (e.target.hasAttribute('data-mt-contador')) contar(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* ---------- Cifras animadas ---------- */
  function contar(el) {
    var num = el.querySelector('[data-mt-valor]');
    if (!num) return;
    var fin = parseFloat(num.getAttribute('data-mt-valor')) || 0;
    if (reducido) { num.textContent = fin; return; }
    var dur = 1600, ini = null;
    function paso(t) {
      if (!ini) ini = t;
      var p = Math.min((t - ini) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      num.textContent = Math.round(fin * e);
      if (p < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  /* ---------- Parallax del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-mt-parallax]');
    if (!imgs.length || reducido) return;
    var pendiente = false;
    function actualizar() {
      pendiente = false;
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var intensidad = parseFloat(img.getAttribute('data-mt-parallax')) || 0;
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        img.style.transform = 'scale(1.08) translate3d(0,' + (centro * -intensidad / 100).toFixed(1) + 'px,0)';
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(actualizar); }
    }, { passive: true });
    actualizar();
  }

  /* ---------- Comparador antes / después ---------- */
  function initComparadores(raiz) {
    (raiz || document).querySelectorAll('.mt-comp').forEach(function (comp) {
      if (comp.dataset.mtListo) return;
      comp.dataset.mtListo = '1';
      var rango = comp.querySelector('.mt-comp__rango');
      if (!rango) return;
      function poner() { comp.style.setProperty('--pos', rango.value + '%'); }
      rango.addEventListener('input', poner);
      poner();
    });
  }

  /* ---------- Selector de colores (portada) ---------- */
  function initColores(raiz) {
    (raiz || document).querySelectorAll('[data-mt-colores]').forEach(function (bloque) {
      if (bloque.dataset.mtListo) return;
      bloque.dataset.mtListo = '1';
      var chips = bloque.querySelectorAll('.mt-col__chip');
      var imgs = bloque.querySelectorAll('.mt-col__img');
      var nombre = bloque.querySelector('.mt-col__nombre');
      chips.forEach(function (chip, i) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('mt-activo'); c.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (im) { im.classList.remove('mt-activo'); });
          chip.classList.add('mt-activo');
          chip.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('mt-activo');
          if (nombre) nombre.textContent = chip.getAttribute('data-nombre') || '';
        });
      });
    });
  }

  /* ---------- Añadir al carrito (con el carrito de Dawn) ---------- */
  function anadirAlCarrito(idVariante, cantidad, boton, msg) {
    var carrito = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var datos = { items: [{ id: Number(idVariante), quantity: Number(cantidad) || 1 }] };
    if (carrito && typeof carrito.getSectionsToRender === 'function') {
      datos.sections = carrito.getSectionsToRender().map(function (s) { return s.id; });
      datos.sections_url = window.location.pathname;
    }
    if (boton) boton.setAttribute('aria-busy', 'true');
    if (msg) msg.textContent = '';
    var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status !== 200) {
          if (msg) msg.textContent = res.description || res.message || 'No se pudo añadir.';
          return;
        }
        if (carrito && typeof carrito.renderContents === 'function' && res.sections) {
          var item = res.items ? res.items[0] : res;
          item.sections = res.sections;
          carrito.renderContents(item);
          if (carrito.classList.contains('is-empty')) carrito.classList.remove('is-empty');
        } else {
          window.location.href = raiz + 'cart';
        }
      })
      .catch(function () { window.location.href = raiz + 'cart'; })
      .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
  }
  window.mtAnadirAlCarrito = anadirAlCarrito;

  function initBotonesCompra(raiz) {
    (raiz || document).querySelectorAll('[data-mt-comprar-directo]').forEach(function (b) {
      if (b.dataset.mtListo) return;
      b.dataset.mtListo = '1';
      b.addEventListener('click', function (e) {
        var id = b.getAttribute('data-mt-comprar-directo');
        if (!id) return;
        e.preventDefault();
        anadirAlCarrito(id, 1, b, null);
      });
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto(raiz) {
    (raiz || document).querySelectorAll('[data-mt-producto]').forEach(function (wrap) {
      if (wrap.dataset.mtListo) return;
      wrap.dataset.mtListo = '1';
      var datosEl = wrap.querySelector('[data-mt-variantes]');
      var variantes = datosEl ? JSON.parse(datosEl.textContent) : [];
      var form = wrap.querySelector('form.mt-prod__form');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = wrap.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.querySelector('span') : null;
      var precio = wrap.querySelector('[data-mt-precio]');
      var antes = wrap.querySelector('[data-mt-antes]');
      var ahorro = wrap.querySelector('[data-mt-ahorro]');
      var msg = wrap.querySelector('[data-mt-msg]');
      var principal = wrap.querySelector('[data-mt-principal]');
      var minis = wrap.querySelectorAll('.mt-prod__mini');
      var cant = wrap.querySelector('[data-mt-cantidad]');

      function verImagen(src, srcset, mini) {
        if (!principal) return;
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = src;
          if (srcset) principal.srcset = srcset; else principal.removeAttribute('srcset');
          principal.style.opacity = '1';
        }, 160);
        minis.forEach(function (m) { m.classList.remove('mt-activo'); });
        if (mini) mini.classList.add('mt-activo');
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { verImagen(m.dataset.src, m.dataset.srcset, m); });
      });

      wrap.querySelectorAll('[data-mt-cant]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(1, (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-mt-cant'), 10));
          cant.value = v;
        });
      });

      function seleccion() {
        var vals = [];
        wrap.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var lab = fs.querySelector('[data-mt-opcion-valor]');
          if (lab && c) lab.textContent = c.getAttribute('data-etiqueta') || c.value;
        });
        return vals;
      }

      function marcarDisponibles(vals) {
        wrap.querySelectorAll('[data-mt-opcion]').forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var prueba = vals.slice();
            prueba[idx] = inp.value;
            var hay = variantes.some(function (v) {
              return v.available && v.options.every(function (o, j) { return o === prueba[j]; });
            });
            var pill = inp.nextElementSibling;
            if (pill) pill.classList.toggle('mt-agotado', !hay);
          });
        });
      }

      function actualizar() {
        var vals = seleccion();
        var v = variantes.find(function (x) {
          return x.options.every(function (o, j) { return o === vals[j]; });
        });
        marcarDisponibles(vals);
        if (!v) {
          if (boton) boton.disabled = true;
          if (textoBoton) textoBoton.textContent = wrap.getAttribute('data-txt-nodisponible');
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = formatoDinero(v.price);
        var tieneAntes = v.compare_at_price && v.compare_at_price > v.price;
        if (antes) { antes.textContent = tieneAntes ? formatoDinero(v.compare_at_price) : ''; antes.hidden = !tieneAntes; }
        if (ahorro) {
          ahorro.hidden = !tieneAntes;
          if (tieneAntes) ahorro.textContent = (wrap.getAttribute('data-txt-ahorro') || '-') + ' ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
        }
        if (boton) boton.disabled = !v.available;
        if (textoBoton) textoBoton.textContent = v.available ? wrap.getAttribute('data-txt-comprar') : wrap.getAttribute('data-txt-agotado');
        if (v.imagen) {
          var mini = null;
          minis.forEach(function (m) { if (m.dataset.mediaId === String(v.media_id)) mini = m; });
          verImagen(v.imagen, null, mini);
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      wrap.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', actualizar);
      });
      seleccion();
      marcarDisponibles(seleccion());

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!inputId || !inputId.value) return;
          anadirAlCarrito(inputId.value, cant ? cant.value : 1, boton, msg);
        });
      }
    });
  }

  function initTodo(raiz) {
    initReveals(raiz);
    initComparadores(raiz);
    initColores(raiz);
    initBotonesCompra(raiz);
    initProducto(raiz);
  }

  function arrancar() {
    initTodo(document);
    initParallax();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  /* Editor de Shopify: re-iniciar al editar secciones */
  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
    e.target.querySelectorAll('.mt-reveal').forEach(function (el) { el.classList.add('mt-visible'); });
  });
})();
